import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { MobilePermission } from './../models/permission.model';
import { PosStorageKey } from './storage.key';
import { StorageService } from 'src/app/pos/services/storage.service';
import { Injectable } from '@angular/core';
import { PinComponent } from '../dialogs/pin/pin.component';
import { PinResponse } from '../models/pin.model';

@Injectable({
  providedIn: 'any',
})
export class PermissionService {
  permissionList: MobilePermission[] = [];
  constructor(private storageService: StorageService, private dialog: MatDialog, private http: HttpClient) {
    this.getMobilePermissionList();
  }

  getMobilePermissionList(): void {
    this.permissionList = this.storageService.get(PosStorageKey.permission);
  }

  public checkMobilePermission(checkData: CheckPermissionInput): boolean {
    const result = [];
    if (this.permissionList.length === 0) return false;

    const extractKey = checkData.key.split('|');

    for (const key of extractKey) {
      const checkKeyInList = this.permissionList.filter((x) => x.permission_module_name === key);

      if (checkKeyInList.length === 0) {
        result.push(false);
        continue;
      }

      const checkAction = checkKeyInList.find((x) => x.permission_name === checkData.action);

      if (!checkAction) {
        result.push(false);
        continue;
      }

      result.push(true);
    }
    return result.every((x) => x === true) ? true : false;
  }

  public async grantPermissionWithPin(): Promise<boolean> {
    const dialog = this.dialog.open(PinComponent, {
      width: '450px',
      maxWidth: '90vw',
      maxHeight: '90vh',
      disableClose: true,
      autoFocus: false,
      data: { mode: 'grant_permission' },
    });
    const pin = await dialog.afterClosed().toPromise();
    return pin ? pin : false;
  }

  checkPin(pin: string): Observable<PinResponse> {
    return this.http.post<PinResponse>('users/verify_pin', { pin });
  }
}

interface CheckPermissionInput {
  key: string;
  action: string;
}
